import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const LoadDispatchLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-BpsKpi' */ './BpsKpi'),
  {
    fallback: <LoadingComponent />,
  }
);

export default LoadDispatchLoadable;
